<div class="
    relative
    h-5/6 w-full
    flex flex-col
    justify-center gap-10
    text-white
    ">

    <div class="
        absolute
        pointer-events-none select-none
        flex flex-col
        text-center items-center align-middle justify-center
        gap-4
        h-full w-full
        bg-pink-500/0
        ">

        <div class="bg-pink-500/0">
            <div class="
                translate-y-6 sm:translate-y-10

                bg-pink-500/0
                text-start
                " id="txt">
                $ADILDOS </div>
            <div class="
                bg-pink-500/0
                text-8xl sm:text-9xl font-extrabold
                " id="txt">
                adildos
            </div>
            <!-- <div>
                {{ _environmentData.ENVIRONMENT_NAME }}
            </div> -->

            <div class="
                h-0 sm:h-40
                bg-blue-500/0
                ">
            </div>
        </div>

        <div class="
            w-full max-w-[50rem] px-4
            {{ (_isLocal ) ? 'bg-red-500/50' : '' }}
            pointer-events-auto select-auto
            {{ (_isLocal ) ? 'bg-green-500/50' : '' }}
            translate-y-28 sm:translate-y-0
            ">

            <!-- <div class="
                h-80 sm:h-0
                bg-blue-500/0
                ">
            </div> -->

            <!-- <a href="https://pump.fun/coin/CrkGJPf9LVPx5YNjVkd9zYTXs8mdeA2L1YPNTg8Kpump" target="_blank" type="button" -->
            <a type="button" data-tooltip-target="tooltip-pumpfun-01" data-tooltip-placement="bottom"
                data-tooltip-placement="bottom" class="
                    border focus:ring-4 focus:outline-none font-medium rounded-lg text-sm
                    px-5 py-2.5 text-center inline-flex items-center focus:ring-gray-600
                    bg-gray-800 border-gray-700 text-white hover:bg-gray-700 me-2 mb-2
                    "
                href="{{  _tokenData.SolTokenAddress ? ('https://pump.fun/coin/' + _tokenData.SolTokenAddress) : '#' }}"
                target="{{  _tokenData.SolTokenAddress ? '_blank' : '' }}">

                <!-- <img src="https://pump.fun/_next/image?url=%2Fpump-santa.png&w=64&q=75" class="w-5 h-5 me-2 -ms-1" alt=""> -->
                <img src="https://t2pp-adds-ws-fe-01-cdn-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/generic-ui/sprites/pumpfun-icon-01.svg"
                    class="w-5 h-5 me-2 -ms-1" alt="">

                {{_localizationService._currentTermsByKey['home-see-on-pump-fun']}}

            </a>

            <ng-container *ngIf="!_tokenData.SolTokenAddress">
                <div id="tooltip-pumpfun-01" role="tooltip"
                    class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white rounded-lg shadow-sm opacity-0 tooltip bg-gray-700">

                    {{_localizationService._currentTermsByKey['soon...']}}

                    <div class="tooltip-arrow" data-popper-arrow></div>
                </div>
            </ng-container>

            <button type="button" data-tooltip-target="tooltip-phantom-01" data-tooltip-placement="bottom" class="
                    border focus:ring-4 focus:outline-none font-medium rounded-lg text-sm
                    px-5 py-2.5 text-center inline-flex items-center focus:ring-gray-600
                    bg-gray-800 border-gray-700 text-white hover:bg-gray-700 me-2 mb-2
                    ">

                <img src="https://t2pp-adds-ws-fe-01-cdn-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/generic-ui/sprites/wallet-phantom-icon-01.svg"
                    class="w-5 h-5 me-2 -ms-1" alt="">

                {{_localizationService._currentTermsByKey['home-add-to-phantom']}}

            </button>

            <div id="tooltip-phantom-01" role="tooltip"
                class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white rounded-lg shadow-sm opacity-0 tooltip bg-gray-700">

                {{_localizationService._currentTermsByKey['soon...']}}

                <div class="tooltip-arrow" data-popper-arrow></div>
            </div>

            <button type="button" data-tooltip-target="tooltip-metamask-01" data-tooltip-placement="bottom" class="
                    border focus:ring-4 focus:outline-none font-medium rounded-lg text-sm
                    px-5 py-2.5 text-center inline-flex items-center focus:ring-gray-600
                    bg-gray-800 border-gray-700 text-white hover:bg-gray-700 me-2 mb-2
                    ">

                <img src="https://t2pp-adds-ws-fe-01-cdn-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/generic-ui/sprites/wallet-metamask-icon-01.svg"
                    class="w-5 h-5 me-2 -ms-1" alt="">

                <!-- <svg aria-hidden="true" class="w-5 h-5 me-2 -ms-1" viewBox="0 0 2405 2501" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1512_1323)">
                        <path d="M2278.79 1730.86L2133.62 2221.69L1848.64 2143.76L2278.79 1730.86Z" fill="#E4761B"
                            stroke="#E4761B" stroke-width="5.94955" />
                        <path d="M1848.64 2143.76L2123.51 1767.15L2278.79 1730.86L1848.64 2143.76Z" fill="#E4761B"
                            stroke="#E4761B" stroke-width="5.94955" />
                        <path
                            d="M2065.2 1360.79L2278.79 1730.86L2123.51 1767.15L2065.2 1360.79ZM2065.2 1360.79L2202.64 1265.6L2278.79 1730.86L2065.2 1360.79Z"
                            fill="#F6851B" stroke="#F6851B" stroke-width="5.94955" />
                        <path
                            d="M1890.29 1081.17L2285.34 919.338L2265.7 1007.99L1890.29 1081.17ZM2253.21 1114.48L1890.29 1081.17L2265.7 1007.99L2253.21 1114.48Z"
                            fill="#763D16" stroke="#763D16" stroke-width="5.94955" />
                        <path
                            d="M2253.21 1114.48L2202.64 1265.6L1890.29 1081.17L2253.21 1114.48ZM2332.34 956.82L2265.7 1007.99L2285.34 919.338L2332.34 956.82ZM2253.21 1114.48L2265.7 1007.99L2318.65 1052.01L2253.21 1114.48Z"
                            fill="#763D16" stroke="#763D16" stroke-width="5.94955" />
                        <path d="M1542.24 2024.17L1641 2055.7L1848.64 2143.75L1542.24 2024.17Z" fill="#E2761B"
                            stroke="#E2761B" stroke-width="5.94955" />
                        <path
                            d="M2202.64 1265.6L2253.21 1114.48L2296.64 1147.8L2202.64 1265.6ZM2202.64 1265.6L1792.71 1130.55L1890.29 1081.17L2202.64 1265.6Z"
                            fill="#763D16" stroke="#763D16" stroke-width="5.94955" />
                        <path d="M1987.86 617.696L1890.29 1081.17L1792.71 1130.55L1987.86 617.696Z" fill="#763D16"
                            stroke="#763D16" stroke-width="5.94955" />
                        <path d="M2285.34 919.338L1890.29 1081.17L1987.86 617.696L2285.34 919.338Z" fill="#763D16"
                            stroke="#763D16" stroke-width="5.94955" />
                        <path d="M1987.86 617.696L2400.16 570.1L2285.34 919.338L1987.86 617.696Z" fill="#763D16"
                            stroke="#763D16" stroke-width="5.94955" />
                        <path d="M2202.64 1265.6L2065.2 1360.79L1792.71 1130.55L2202.64 1265.6Z" fill="#F6851B"
                            stroke="#F6851B" stroke-width="5.94955" />
                        <path d="M2382.31 236.33L2400.16 570.1L1987.86 617.696L2382.31 236.33Z" fill="#763D16"
                            stroke="#763D16" stroke-width="5.94955" />
                        <path d="M2382.31 236.33L1558.3 835.45L1547.59 429.095L2382.31 236.33Z" fill="#E2761B"
                            stroke="#E2761B" stroke-width="5.94955" />
                        <path d="M934.789 380.309L1547.59 429.095L1558.3 835.449L934.789 380.309Z" fill="#F6851B"
                            stroke="#F6851B" stroke-width="5.94955" />
                        <path d="M1792.71 1130.55L1558.3 835.449L1987.86 617.696L1792.71 1130.55Z" fill="#763D16"
                            stroke="#763D16" stroke-width="5.94955" />
                        <path d="M1792.71 1130.55L2065.2 1360.79L1682.65 1403.04L1792.71 1130.55Z" fill="#E4761B"
                            stroke="#E4761B" stroke-width="5.94955" />
                        <path d="M1682.65 1403.04L1558.3 835.449L1792.71 1130.55L1682.65 1403.04Z" fill="#E4761B"
                            stroke="#E4761B" stroke-width="5.94955" />
                        <path d="M1987.86 617.696L1558.3 835.45L2382.31 236.33L1987.86 617.696Z" fill="#763D16"
                            stroke="#763D16" stroke-width="5.94955" />
                        <path d="M940.144 2134.24L1134.69 2337.11L869.939 2096.16L940.144 2134.24Z" fill="#C0AD9E"
                            stroke="#C0AD9E" stroke-width="5.94955" />
                        <path d="M1848.64 2143.75L1940.86 1793.33L2123.51 1767.15L1848.64 2143.75Z" fill="#CD6116"
                            stroke="#CD6116" stroke-width="5.94955" />
                        <path d="M151.234 1157.92L487.978 803.917L194.666 1115.67L151.234 1157.92Z" fill="#E2761B"
                            stroke="#E2761B" stroke-width="5.94955" />
                        <path
                            d="M2123.51 1767.15L1940.86 1793.33L2065.2 1360.79L2123.51 1767.15ZM1558.3 835.449L1230.48 824.74L934.789 380.309L1558.3 835.449Z"
                            fill="#F6851B" stroke="#F6851B" stroke-width="5.94955" />
                        <path d="M2065.2 1360.79L1940.86 1793.33L1930.74 1582.12L2065.2 1360.79Z" fill="#E4751F"
                            stroke="#E4751F" stroke-width="5.94955" />
                        <path d="M1682.65 1403.04L2065.2 1360.79L1930.74 1582.12L1682.65 1403.04Z" fill="#CD6116"
                            stroke="#CD6116" stroke-width="5.94955" />
                        <path d="M1230.48 824.74L1558.3 835.449L1682.65 1403.04L1230.48 824.74Z" fill="#F6851B"
                            stroke="#F6851B" stroke-width="5.94955" />
                        <path
                            d="M1230.48 824.74L345.784 6.08252L934.79 380.309L1230.48 824.74ZM934.195 2258.58L165.513 2496.56L12.0146 1910.53L934.195 2258.58Z"
                            fill="#E4761B" stroke="#E4761B" stroke-width="5.94955" />
                        <path d="M265.465 1304.27L555.803 1076.41L799.14 1132.93L265.465 1304.27Z" fill="#763D16"
                            stroke="#763D16" stroke-width="5.94955" />
                        <path d="M799.139 1132.93L555.803 1076.41L686.098 538.567L799.139 1132.93Z" fill="#763D16"
                            stroke="#763D16" stroke-width="5.94955" />
                        <path d="M194.666 1115.67L555.803 1076.41L265.465 1304.27L194.666 1115.67Z" fill="#763D16"
                            stroke="#763D16" stroke-width="5.94955" />
                        <path d="M1930.74 1582.12L1780.81 1506.56L1682.65 1403.04L1930.74 1582.12Z" fill="#CD6116"
                            stroke="#CD6116" stroke-width="5.94955" />
                        <path d="M194.666 1115.67L169.083 980.618L555.803 1076.41L194.666 1115.67Z" fill="#763D16"
                            stroke="#763D16" stroke-width="5.94955" />
                        <path d="M1749.88 1676.72L1780.81 1506.56L1930.74 1582.12L1749.88 1676.72Z" fill="#233447"
                            stroke="#233447" stroke-width="5.94955" />
                        <path d="M1940.86 1793.33L1749.88 1676.72L1930.74 1582.12L1940.86 1793.33Z" fill="#F6851B"
                            stroke="#F6851B" stroke-width="5.94955" />
                        <path
                            d="M555.803 1076.41L169.082 980.618L137.55 866.982L555.803 1076.41ZM686.098 538.567L555.803 1076.41L137.55 866.982L686.098 538.567ZM686.098 538.567L1230.48 824.74L799.139 1132.93L686.098 538.567Z"
                            fill="#763D16" stroke="#763D16" stroke-width="5.94955" />
                        <path
                            d="M799.14 1132.93L1230.48 824.74L1422.65 1411.96L799.14 1132.93ZM1422.65 1411.96L826.508 1399.47L799.14 1132.93L1422.65 1411.96Z"
                            fill="#E4761B" stroke="#E4761B" stroke-width="5.94955" />
                        <path
                            d="M265.465 1304.27L799.14 1132.93L826.508 1399.47L265.465 1304.27ZM1682.65 1403.04L1422.65 1411.96L1230.48 824.74L1682.65 1403.04Z"
                            fill="#F6851B" stroke="#F6851B" stroke-width="5.94955" />
                        <path d="M1780.81 1506.56L1749.88 1676.72L1682.65 1403.04L1780.81 1506.56Z" fill="#CD6116"
                            stroke="#CD6116" stroke-width="5.94955" />
                        <path d="M345.784 6.08252L1230.48 824.74L686.098 538.567L345.784 6.08252Z" fill="#763D16"
                            stroke="#763D16" stroke-width="5.94955" />
                        <path d="M12.0146 1910.53L758.088 1879.59L934.195 2258.58L12.0146 1910.53Z" fill="#E4761B"
                            stroke="#E4761B" stroke-width="5.94955" />
                        <path d="M934.194 2258.58L758.088 1879.59L1124.58 1861.75L934.194 2258.58Z" fill="#CD6116"
                            stroke="#CD6116" stroke-width="5.94955" />
                        <path
                            d="M1749.88 1676.72L1940.86 1793.33L2046.16 2041.42L1749.88 1676.72ZM826.508 1399.47L12.0146 1910.53L265.465 1304.27L826.508 1399.47ZM758.088 1879.59L12.0146 1910.53L826.508 1399.47L758.088 1879.59ZM1682.65 1403.04L1731.43 1580.33L1495.83 1594.02L1682.65 1403.04ZM1495.83 1594.02L1422.65 1411.96L1682.65 1403.04L1495.83 1594.02Z"
                            fill="#F6851B" stroke="#F6851B" stroke-width="5.94955" />
                        <path d="M1134.69 2337.11L934.194 2258.58L1631.48 2375.79L1134.69 2337.11Z" fill="#C0AD9E"
                            stroke="#C0AD9E" stroke-width="5.94955" />
                        <path d="M265.465 1304.27L151.234 1157.91L194.666 1115.67L265.465 1304.27Z" fill="#763D16"
                            stroke="#763D16" stroke-width="5.94955" />
                        <path d="M1710.61 2288.92L1631.48 2375.79L934.194 2258.58L1710.61 2288.92Z" fill="#D7C1B3"
                            stroke="#D7C1B3" stroke-width="5.94955" />
                        <path d="M1748.09 2075.93L934.194 2258.58L1124.58 1861.75L1748.09 2075.93Z" fill="#E4761B"
                            stroke="#E4761B" stroke-width="5.94955" />
                        <path d="M934.194 2258.58L1748.09 2075.93L1710.61 2288.92L934.194 2258.58Z" fill="#D7C1B3"
                            stroke="#D7C1B3" stroke-width="5.94955" />
                        <path
                            d="M137.55 866.982L110.777 409.462L686.098 538.567L137.55 866.982ZM194.665 1115.67L115.536 1035.35L169.082 980.618L194.665 1115.67Z"
                            fill="#763D16" stroke="#763D16" stroke-width="5.94955" />
                        <path d="M1289.38 1529.76L1422.65 1411.96L1403.61 1699.92L1289.38 1529.76Z" fill="#CD6116"
                            stroke="#CD6116" stroke-width="5.94955" />
                        <path d="M1422.65 1411.96L1289.38 1529.76L1095.43 1630.31L1422.65 1411.96Z" fill="#CD6116"
                            stroke="#CD6116" stroke-width="5.94955" />
                        <path d="M2046.16 2041.42L2009.87 2014.65L1749.88 1676.72L2046.16 2041.42Z" fill="#F6851B"
                            stroke="#F6851B" stroke-width="5.94955" />
                        <path d="M1095.43 1630.31L826.508 1399.47L1422.65 1411.96L1095.43 1630.31Z" fill="#CD6116"
                            stroke="#CD6116" stroke-width="5.94955" />
                        <path d="M1403.61 1699.92L1422.65 1411.96L1495.83 1594.02L1403.61 1699.92Z" fill="#E4751F"
                            stroke="#E4751F" stroke-width="5.94955" />
                        <path d="M89.3589 912.199L137.55 866.982L169.083 980.618L89.3589 912.199Z" fill="#763D16"
                            stroke="#763D16" stroke-width="5.94955" />
                        <path d="M1403.61 1699.92L1095.43 1630.31L1289.38 1529.76L1403.61 1699.92Z" fill="#233447"
                            stroke="#233447" stroke-width="5.94955" />
                        <path d="M686.098 538.567L110.777 409.462L345.784 6.08252L686.098 538.567Z" fill="#763D16"
                            stroke="#763D16" stroke-width="5.94955" />
                        <path d="M1631.48 2375.79L1664.2 2465.03L1134.69 2337.12L1631.48 2375.79Z" fill="#C0AD9E"
                            stroke="#C0AD9E" stroke-width="5.94955" />
                        <path d="M1124.58 1861.75L1095.43 1630.31L1403.61 1699.92L1124.58 1861.75Z" fill="#F6851B"
                            stroke="#F6851B" stroke-width="5.94955" />
                        <path d="M826.508 1399.47L1095.43 1630.31L1124.58 1861.75L826.508 1399.47Z" fill="#E4751F"
                            stroke="#E4751F" stroke-width="5.94955" />
                        <path
                            d="M1495.83 1594.02L1731.43 1580.33L2009.87 2014.65L1495.83 1594.02ZM826.508 1399.47L1124.58 1861.75L758.088 1879.59L826.508 1399.47Z"
                            fill="#F6851B" stroke="#F6851B" stroke-width="5.94955" />
                        <path d="M1495.83 1594.02L1788.55 2039.64L1403.61 1699.92L1495.83 1594.02Z" fill="#E4751F"
                            stroke="#E4751F" stroke-width="5.94955" />
                        <path d="M1403.61 1699.92L1788.55 2039.64L1748.09 2075.93L1403.61 1699.92Z" fill="#F6851B"
                            stroke="#F6851B" stroke-width="5.94955" />
                        <path
                            d="M1748.09 2075.93L1124.58 1861.75L1403.61 1699.92L1748.09 2075.93ZM2009.87 2014.65L1788.55 2039.64L1495.83 1594.02L2009.87 2014.65Z"
                            fill="#F6851B" stroke="#F6851B" stroke-width="5.94955" />
                        <path
                            d="M2068.18 2224.07L1972.99 2415.05L1664.2 2465.03L2068.18 2224.07ZM1664.2 2465.03L1631.48 2375.79L1710.61 2288.92L1664.2 2465.03Z"
                            fill="#C0AD9E" stroke="#C0AD9E" stroke-width="5.94955" />
                        <path
                            d="M1710.61 2288.92L1768.92 2265.72L1664.2 2465.03L1710.61 2288.92ZM1664.2 2465.03L1768.92 2265.72L2068.18 2224.07L1664.2 2465.03Z"
                            fill="#C0AD9E" stroke="#C0AD9E" stroke-width="5.94955" />
                        <path d="M2009.87 2014.65L2083.05 2059.27L1860.54 2086.04L2009.87 2014.65Z" fill="#161616"
                            stroke="#161616" stroke-width="5.94955" />
                        <path
                            d="M1860.54 2086.04L1788.55 2039.64L2009.87 2014.65L1860.54 2086.04ZM1834.96 2121.15L2105.66 2088.42L2068.18 2224.07L1834.96 2121.15Z"
                            fill="#161616" stroke="#161616" stroke-width="5.94955" />
                        <path
                            d="M2068.18 2224.07L1768.92 2265.72L1834.96 2121.15L2068.18 2224.07ZM1768.92 2265.72L1710.61 2288.92L1748.09 2075.93L1768.92 2265.72ZM1748.09 2075.93L1788.55 2039.64L1860.54 2086.04L1748.09 2075.93ZM2083.05 2059.27L2105.66 2088.42L1834.96 2121.15L2083.05 2059.27Z"
                            fill="#161616" stroke="#161616" stroke-width="5.94955" />
                        <path
                            d="M1834.96 2121.15L1860.54 2086.04L2083.05 2059.27L1834.96 2121.15ZM1748.09 2075.93L1834.96 2121.15L1768.92 2265.72L1748.09 2075.93Z"
                            fill="#161616" stroke="#161616" stroke-width="5.94955" />
                        <path d="M1860.54 2086.04L1834.96 2121.15L1748.09 2075.93L1860.54 2086.04Z" fill="#161616"
                            stroke="#161616" stroke-width="5.94955" />
                    </g>
                    <defs>
                        <clipPath id="clip0_1512_1323">
                            <rect width="2404" height="2500" fill="white" transform="translate(0.519043 0.132812)" />
                        </clipPath>
                    </defs>
                </svg> -->

                {{_localizationService._currentTermsByKey['home-add-to-metamask']}}

            </button>

            <div id="tooltip-metamask-01" role="tooltip"
                class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white rounded-lg shadow-sm opacity-0 tooltip bg-gray-700">

                {{_localizationService._currentTermsByKey['soon...']}}

                <div class="tooltip-arrow" data-popper-arrow></div>
            </div>

        </div>

        <div class="
            mb-2
            translate-y-24 sm:translate-y-0
            {{ (_isLocal ) ? 'bg-red-500/50' : '' }}">
            <div class="opacity-70 w-80 text-sm text-shadow" id="txt">
                {{_localizationService._currentTermsByKey['home-caution-with-scams-fake-profiles-contracts-links']}}
            </div>
        </div>

    </div>

    <threejs-base-scene #_threeJsBaseScene class="
        h-full w-full
        "></threejs-base-scene>

</div>

<div class="
    min-h-5/6 w-full
    bg-white/5
    flex flex-col
    justify-start items-center gap-10
    text-white
    ">

    <div class="
        relative
        flex flex-col
        text-center items-center align-middle justify-start gap-4
        w-full sm:w-[30rem]
        py-8
        bg-green-500/0
        ">

        <div class="bg-pink-500/0">
            <div class="bg-pink-500/0 text-3xl font-extrabold" id="txt">
                {{_localizationService._currentTermsByKey['home-roadmap-title']}}
            </div>
            <div class="bg-pink-500/0 italic opacity-40" id="txt">
                {{_localizationService._currentTermsByKey['home-where-and-when-will-pica-pass']}}
            </div>
        </div>

        <div class="
            relative
            bg-pink-500/0
            w-full
            pl-4 pr-10 sm:pl-0 sm:pr-4
            mb-10
            ">

            <ol class="relative border-s border-gray-700">

                <li class="mb-10 ms-4">
                    <div class="absolute w-3 h-3 rounded-full mt-1.5 -start-1.5 border border-gray-900 bg-gray-700">
                    </div>

                    <div class="
                        flex flex-col items-start text-left
                        bg-green-500/0
                        ">
                        <time class="mb-1 text-sm font-normal leading-none text-gray-500">
                            {{_localizationService._currentTermsByKey['home-april-2026']}}
                        </time>
                        <h3 class="text-lg font-semibold text-white">

                            {{_localizationService._currentTermsByKey['home-website-launch']}}
                            <img src="https://t2pp-adds-ws-fe-01-cdn-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/generic-ui/sprites/green-check-01.png"
                                class="
                                    inline
                                    relative
                                    w-4 h-4
                                    ml-1
                                    ">

                        </h3>
                        <h3 class="text-lg font-semibold text-white bg-pink-500/0">

                            {{_localizationService._currentTermsByKey['home-twitter-launch']}}

                            <ng-container *ngIf="!_socialData.TwitterUsername">
                                <img src="https://t2pp-adds-ws-fe-01-cdn-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/generic-ui/sprites/loading-icon-01.png"
                                    class="
                                        inline
                                        relative
                                        animate-spin
                                        w-4 h-4
                                        ml-1
                                        ">
                            </ng-container>

                            <ng-container *ngIf="_socialData.TwitterUsername">
                                <img src="https://t2pp-adds-ws-fe-01-cdn-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/generic-ui/sprites/green-check-01.png"
                                    class="
                                    inline
                                    relative
                                    w-4 h-4
                                    ml-1
                                    ">
                            </ng-container>
                        </h3>
                        <h3 class="text-lg font-semibold text-white bg-pink-500/0">

                            {{_localizationService._currentTermsByKey['home-token-launch']}}

                            <ng-container *ngIf="!_tokenData.SolTokenAddress">
                                <img src="https://t2pp-adds-ws-fe-01-cdn-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/generic-ui/sprites/loading-icon-01.png"
                                    class="
                                        inline
                                        relative
                                        animate-spin
                                        w-4 h-4
                                        ml-1
                                        ">
                            </ng-container>

                            <ng-container *ngIf="_tokenData.SolTokenAddress">
                                <img src="https://t2pp-adds-ws-fe-01-cdn-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/generic-ui/sprites/green-check-01.png"
                                    class="
                                    inline
                                    relative
                                    w-4 h-4
                                    ml-1
                                    ">
                            </ng-container>

                        </h3>
                    </div>
                </li>

                <li class="mb-10 ms-4">
                    <div class="absolute w-3 h-3 rounded-full mt-1.5 -start-1.5 border border-gray-900 bg-gray-700">
                    </div>

                    <div class="
                        flex flex-col items-start text-left
                        bg-green-500/0
                        ">
                        <time class="mb-1 text-sm font-normal leading-none text-gray-500">
                            {{_localizationService._currentTermsByKey['home-second-quarter-2026']}}
                        </time>
                        <h3 class="text-lg font-semibold text-white bg-pink-500/0">

                            {{_localizationService._currentTermsByKey['home-telegram-group']}}
                            <img src="https://t2pp-adds-ws-fe-01-cdn-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/generic-ui/sprites/loading-icon-01.png"
                                class="
                                    inline
                                    relative
                                    animate-spin
                                    w-4 h-4
                                    ml-1
                                    ">

                        </h3>
                        <h3 class="text-lg font-semibold text-white bg-pink-500/0">

                            {{_localizationService._currentTermsByKey['home-discord-server']}}
                            <img src="https://t2pp-adds-ws-fe-01-cdn-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/generic-ui/sprites/loading-icon-01.png"
                                class="
                                    inline
                                    relative
                                    animate-spin
                                    w-4 h-4
                                    ml-1
                                    ">

                        </h3>
                    </div>
                </li>

                <!-- <li class="mb-10 ms-4">
                    <div class="absolute w-3 h-3 rounded-full mt-1.5 -start-1.5 border border-gray-900 bg-gray-700">
                    </div>

                    <div class="
                        flex flex-col items-start text-left
                        bg-green-500/0
                        ">
                        <time class="mb-1 text-sm font-normal leading-none text-gray-500">

                            {{_localizationService._currentTermsByKey['home-second-quarter-2025']}}

                        </time>
                        <h3 class="text-lg font-semibold text-white bg-pink-500/0">

                            {{_localizationService._currentTermsByKey['home-blackjack-game']}}
                            <img src="https://t2pp-adds-ws-fe-01-cdn-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/generic-ui/sprites/loading-icon-01.png"
                                class="
                                    inline
                                    relative
                                    animate-spin
                                    w-4 h-4
                                    ml-1
                                    ">

                        </h3>
                        <p class="text-base font-normal text-gray-400">
                            {{_localizationService._currentTermsByKey['home-blackjack-21-against-players-or-table']}}
                        </p>
                    </div>
                </li> -->

                <!-- <li class="mb-10 ms-4">
                    <div class="absolute w-3 h-3 rounded-full mt-1.5 -start-1.5 border border-gray-900 bg-gray-700">
                    </div>

                    <div class="
                        flex flex-col items-start text-left
                        bg-green-500/0
                        ">
                        <time class="mb-1 text-sm font-normal leading-none text-gray-500">
                            {{_localizationService._currentTermsByKey['home-third-quarter-2025']}}
                        </time>
                        <h3 class="text-lg font-semibold text-white bg-pink-500/0">

                            {{_localizationService._currentTermsByKey['home-roadmap-review']}}
                            <img src="https://t2pp-adds-ws-fe-01-cdn-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/generic-ui/sprites/loading-icon-01.png"
                                class="
                                    inline
                                    relative
                                    animate-spin
                                    w-4 h-4
                                    ml-1
                                    ">

                        </h3>
                        <p class="text-base font-normal text-gray-400">
                            {{_localizationService._currentTermsByKey['home-roadmap-review-validation']}}
                        </p>
                        <h3 class="text-lg font-semibold text-white bg-pink-500/0">

                            {{_localizationService._currentTermsByKey['home-poker-game']}}
                            <img src="https://t2pp-adds-ws-fe-01-cdn-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/generic-ui/sprites/loading-icon-01.png"
                                class="
                                    inline
                                    relative
                                    animate-spin
                                    w-4 h-4
                                    ml-1
                                    ">

                        </h3>
                        <p class="text-base font-normal text-gray-400">
                            {{_localizationService._currentTermsByKey['home-poker-texas-holdem-against-players']}}
                        </p>
                    </div>
                </li> -->

                <li class="mb-10 ms-4">
                    <div class="absolute w-3 h-3 rounded-full mt-1.5 -start-1.5 border border-gray-900 bg-gray-700">
                    </div>

                    <div class="
                        flex flex-col items-start text-left
                        bg-green-500/0
                        ">
                        <time class="mb-1 text-sm font-normal leading-none text-gray-500">
                            {{_localizationService._currentTermsByKey['home-third-quarter-2026']}}
                        </time>
                        <!-- <h3 class="text-lg font-semibold text-white bg-pink-500/0">

                            {{_localizationService._currentTermsByKey['home-project-p']}}
                            <img src="https://t2pp-adds-ws-fe-01-cdn-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/generic-ui/sprites/loading-icon-01.png"
                                class="
                                    inline
                                    relative
                                    animate-spin
                                    w-4 h-4
                                    ml-1
                                    ">

                        </h3>
                        <p class="text-base font-normal text-gray-400">
                            {{_localizationService._currentTermsByKey['home-game-with-own-token-nfts-staking']}}
                        </p> -->

                        <h3 class="text-lg font-semibold text-white bg-pink-500/0">

                            {{_localizationService._currentTermsByKey['home-roadmap-review']}}
                            <img src="https://t2pp-adds-ws-fe-01-cdn-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/generic-ui/sprites/loading-icon-01.png"
                                class="
                                        inline
                                        relative
                                        animate-spin
                                        w-4 h-4
                                        ml-1
                                        ">

                        </h3>
                        <p class="text-base font-normal text-gray-400">
                            {{_localizationService._currentTermsByKey['home-roadmap-content-review']}}
                        </p>
                    </div>
                </li>

            </ol>

        </div>


    </div>

</div>

<!--

<div class="
    w-full
    bg-white/10
    flex flex-col
    justify-start items-center gap-10
    text-white
    ">

    <div class="
        relative
        flex flex-col
        text-center items-center align-middle justify-start gap-4
        w-full sm:w-[30rem]
        py-8
        bg-green-500/0
        ">

        <div class="bg-pink-500/0">
            <div class="bg-pink-500/0 text-3xl font-extrabold" id="txt">
                {{_localizationService._currentTermsByKey['home-about-title']}}
            </div>
            <div class="bg-pink-500/0 italic opacity-40" id="txt">
                {{_localizationService._currentTermsByKey['home-pichanha-coin-history']}}
            </div>
        </div>

        <div class="
            relative
            bg-pink-500/0
            w-full
            pl-4 pr-10 sm:pl-0 sm:pr-4
            mb-10
            ">

            <h3 class="text-lg font-semibold text-white mt-4">
                {{_localizationService._currentTermsByKey['home-origin-title']}}
            </h3>
            <p class="text-base font-normal text-gray-400 mt-2">
                {{_localizationService._currentTermsByKey['home-brazil-2022-election-history']}}
            </p>

            <p class="text-base font-normal text-gray-400 mt-2">
                {{_localizationService._currentTermsByKey['home-candidate-elected']}}
            </p>

            <p class="text-base font-normal text-gray-400 mt-2">
                {{_localizationService._currentTermsByKey['home-picanha-de-lula-meme']}}
            </p>

            <h3 class="text-lg font-semibold text-white mt-4">
                {{_localizationService._currentTermsByKey['home-double-meaning']}}
            </h3>

            <p class="text-base font-normal text-gray-400 mt-2">
                {{_localizationService._currentTermsByKey['home-picanha-symbol-meaning']}}
            </p>

        </div>

    </div>

</div>

-->

<div class="
    w-full
    bg-blue-500/45
    flex flex-col
    justify-start items-center gap-10
    text-white
    ">

    <div class="
        relative
        flex flex-col
        text-center items-center align-middle justify-start gap-4
        w-full sm:w-[30rem]
        py-8
        bg-green-500/0
        ">

        <div class="bg-pink-500/0">
            <div class="bg-pink-500/0 text-3xl font-extrabold" id="txt">
                {{_localizationService._currentTermsByKey['home-security-title']}}
            </div>
            <div class="bg-pink-500/0 italic opacity-40" id="txt">
                {{_localizationService._currentTermsByKey['home-avoid-hands-on-your-picas']}}
            </div>
        </div>

        <div class="
            relative
            bg-pink-500/0
            w-full
            pl-4 pr-10 sm:pl-0 sm:pr-4
            mb-10
            ">

            <p class="text-base font-normal text-gray-400 mt-2"
                [innerHTML]="_localizationService._currentTermsByKey['home-caution-with-scams-profiles-contracts-fakes']">
            </p>

            <h3 class="text-lg font-semibold text-white mt-4">
                {{_localizationService._currentTermsByKey['home-official-contracts']}}
            </h3>

            <h4 class="text-lg font-semibold text-white mt-4">
                {{_localizationService._currentTermsByKey['home-picanha-coin']}}
            </h4>

            <ng-container *ngIf="_tokenData.SolTokenAddress">
                <p class="text-base font-normal text-gray-400 mt-2">
                    {{ _tokenData.SolTokenAddress }}
                </p>
            </ng-container>
            <ng-container *ngIf="!_tokenData.SolTokenAddress">
                <p class="text-base font-normal text-gray-400 mt-2 italic">
                    {{_localizationService._currentTermsByKey['soon...']}}
                </p>
            </ng-container>

        </div>

    </div>

</div>

<!--

<div class="
    hidden
    w-full
    bg-white/10
    flex flex-col
    justify-start items-center gap-10
    text-white
    ">

    <div class="
        relative
        flex flex-col
        text-center items-center align-middle justify-start gap-4
        w-full sm:w-[30rem]
        py-8
        bg-green-500/0
        ">

        <div class="bg-pink-500/0">
            <div class="bg-pink-500/0 text-3xl font-extrabold" id="txt">
                {{_localizationService._currentTermsByKey['home-about-the-team-title']}}
            </div>
            <div class="bg-pink-500/0 italic opacity-40" id="txt">
                {{_localizationService._currentTermsByKey['home-who-conceived-pica-title']}}
            </div>
        </div>

        <div class="
            relative
            bg-pink-500/0
            w-full
            pl-4 pr-10 sm:pl-0 sm:pr-4
            mb-10
            ">

            <h3 class="text-lg font-semibold text-white mt-4">
                {{_localizationService._currentTermsByKey['home-one-developer']}}
            </h3>
            <p class="text-base font-normal text-gray-400 mt-2">
                {{_localizationService._currentTermsByKey['home-team-is-one-dev']}}
            </p>

            <h3 class="text-lg font-semibold text-white mt-4">
                {{_localizationService._currentTermsByKey['home-about-the-1']}}
            </h3>
            <p class="text-base font-normal text-gray-400 mt-2">
                {{_localizationService._currentTermsByKey['home-3d-artist-gamedev-cs-player-hardware-nerd']}}
            </p>

            <p class="text-base font-normal text-gray-400 mt-2">
                {{_localizationService._currentTermsByKey['home-tech-enthusiast-programmer-crypto-gaming-loss']}}
            </p>

            <p class="text-base font-normal text-gray-400 mt-2">
                {{_localizationService._currentTermsByKey['home-my-goal-transparency']}}
            </p>

            <h3 class="text-lg font-semibold text-white mt-4">
                {{_localizationService._currentTermsByKey['home-anonymity-title']}}
            </h3>
            <p class="text-base font-normal text-gray-400 mt-2">
                {{_localizationService._currentTermsByKey['home-prefer-not-anonymous-but-didnt-calculate-implications']}}
            </p>

            <h3 class="text-lg font-semibold text-white mt-4">
                {{_localizationService._currentTermsByKey['home-medium-long-term']}}
            </h3>
            <p class="text-base font-normal text-gray-400 mt-2">
                {{_localizationService._currentTermsByKey['home-no-pump-and-dump-no-rug-pull-long-term-goals']}}
            </p>

            <p class="text-base font-normal text-gray-400 mt-2 italic">
                {{_localizationService._currentTermsByKey['home-hope-not-to-become-what-im-trying-to-destroy']}}
            </p>

        </div>

    </div>

</div>

-->

<div class="
    hidden
    w-full
    bg-white/5
    flex flex-col
    justify-start items-center gap-10
    text-white
    ">


    <div class="max-w-sm w-full bg-white rounded-lg shadow dark:bg-gray-800 p-4 md:p-6">

        <div class="flex justify-between mb-3">
            <div class="flex justify-center items-center">
                <h5 class="text-xl font-bold leading-none text-gray-900 dark:text-white pe-1">Website traffic</h5>
                <svg data-popover-target="chart-info" data-popover-placement="bottom"
                    class="w-3.5 h-3.5 text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white cursor-pointer ms-1"
                    aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                    <path
                        d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm0 16a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm1-5.034V12a1 1 0 0 1-2 0v-1.418a1 1 0 0 1 1.038-.999 1.436 1.436 0 0 0 1.488-1.441 1.501 1.501 0 1 0-3-.116.986.986 0 0 1-1.037.961 1 1 0 0 1-.96-1.037A3.5 3.5 0 1 1 11 11.466Z" />
                </svg>
                <div data-popover id="chart-info" role="tooltip"
                    class="absolute z-10 invisible inline-block text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-sm opacity-0 w-72 dark:bg-gray-800 dark:border-gray-600 dark:text-gray-400">
                    <div class="p-3 space-y-2">
                        <h3 class="font-semibold text-gray-900 dark:text-white">Activity growth - Incremental</h3>
                        <p>Report helps navigate cumulative growth of community activities. Ideally, the chart should
                            have a growing trend, as stagnating chart signifies a significant decrease of community
                            activity.</p>
                        <h3 class="font-semibold text-gray-900 dark:text-white">Calculation</h3>
                        <p>For each date bucket, the all-time volume of activities is calculated. This means that
                            activities in period n contain all activities up to period n, plus the activities generated
                            by your community in period.</p>
                        <a href="#"
                            class="flex items-center font-medium text-blue-600 dark:text-blue-500 dark:hover:text-blue-600 hover:text-blue-700 hover:underline">Read
                            more <svg class="w-2 h-2 ms-1.5 rtl:rotate-180" aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                    stroke-width="2" d="m1 9 4-4-4-4" />
                            </svg></a>
                    </div>
                    <div data-popper-arrow></div>
                </div>
            </div>
            <div>
                <button type="button" data-tooltip-target="data-tooltip" data-tooltip-placement="bottom"
                    class="hidden sm:inline-flex items-center justify-center text-gray-500 w-8 h-8 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 rounded-lg text-sm"><svg
                        class="w-3.5 h-3.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 16 18">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M8 1v11m0 0 4-4m-4 4L4 8m11 4v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3" />
                    </svg><span class="sr-only">Download data</span>
                </button>
                <div id="data-tooltip" role="tooltip"
                    class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip dark:bg-gray-700">
                    Download CSV
                    <div class="tooltip-arrow" data-popper-arrow></div>
                </div>
            </div>
        </div>

        <div>
            <div class="flex" id="devices">
                <div class="flex items-center me-4">
                    <input id="desktop" type="checkbox" value="desktop"
                        class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                    <label for="desktop"
                        class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Desktop</label>
                </div>
                <div class="flex items-center me-4">
                    <input id="tablet" type="checkbox" value="tablet"
                        class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                    <label for="tablet" class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Tablet</label>
                </div>
                <div class="flex items-center me-4">
                    <input id="mobile" type="checkbox" value="mobile"
                        class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                    <label for="mobile" class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Mobile</label>
                </div>
            </div>
        </div>

        <!-- Donut Chart -->
        <div class="py-6" id="donut-chart"></div>

        <div class="grid grid-cols-1 items-center border-gray-200 border-t dark:border-gray-700 justify-between">
            <div class="flex justify-between items-center pt-5">
                <!-- Button -->
                <button id="dropdownDefaultButton" data-dropdown-toggle="lastDaysdropdown"
                    data-dropdown-placement="bottom"
                    class="text-sm font-medium text-gray-500 dark:text-gray-400 hover:text-gray-900 text-center inline-flex items-center dark:hover:text-white"
                    type="button">
                    Last 7 days
                    <svg class="w-2.5 m-2.5 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 10 6">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="m1 1 4 4 4-4" />
                    </svg>
                </button>
                <div id="lastDaysdropdown"
                    class="z-10 hidden bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700">
                    <ul class="py-2 text-sm text-gray-700 dark:text-gray-200" aria-labelledby="dropdownDefaultButton">
                        <li>
                            <a href="#"
                                class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">Yesterday</a>
                        </li>
                        <li>
                            <a href="#"
                                class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">Today</a>
                        </li>
                        <li>
                            <a href="#"
                                class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">Last
                                7 days</a>
                        </li>
                        <li>
                            <a href="#"
                                class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">Last
                                30 days</a>
                        </li>
                        <li>
                            <a href="#"
                                class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">Last
                                90 days</a>
                        </li>
                    </ul>
                </div>
                <a href="#"
                    class="uppercase text-sm font-semibold inline-flex items-center rounded-lg text-blue-600 hover:text-blue-700 dark:hover:text-blue-500  hover:bg-gray-100 dark:hover:bg-gray-700 dark:focus:ring-gray-700 dark:border-gray-700 px-3 py-2">
                    Traffic analysis
                    <svg class="w-2.5 h-2.5 ms-1.5 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                        fill="none" viewBox="0 0 6 10">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="m1 9 4-4-4-4" />
                    </svg>
                </a>
            </div>
        </div>
    </div>


</div>

<div class="
    flex flex-col
    justify-start items-center gap-10
    text-white
    ">

    <div class="
        flex flex-col
        text-center items-center align-middle justify-center gap-4
        py-8
        bg-pink-500/0
        ">

        <div class="
            flex flex-col
            h-full
            bg-green-500/0
            text-center items-center align-middle justify-center gap-4
            ">
            <div class="opacity-40" id="txt">
                <span>
                    © 2025 adildos Protocol. All rights reserved.
                </span>
            </div>
        </div>

    </div>

</div>


<app-nav-bar [SocialData]="_socialData"></app-nav-bar>

<app-version-panel></app-version-panel>
